var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.47499C11.8667 9.47499 11.7377 9.44999 11.613 9.39999C11.4877 9.34999 11.3833 9.28332 11.3 9.19999L8.19999 6.09999C8.01665 5.91665 7.92499 5.68332 7.92499 5.39999C7.92499 5.11665 8.01665 4.88332 8.19999 4.69999C8.38332 4.51665 8.61665 4.42499 8.89999 4.42499C9.18332 4.42499 9.41665 4.51665 9.59999 4.69999L12 7.09999L14.4 4.69999C14.5833 4.51665 14.8167 4.42499 15.1 4.42499C15.3833 4.42499 15.6167 4.51665 15.8 4.69999C15.9833 4.88332 16.075 5.11665 16.075 5.39999C16.075 5.68332 15.9833 5.91665 15.8 6.09999L12.7 9.19999C12.6 9.29999 12.4917 9.37065 12.375 9.41199C12.2583 9.45399 12.1333 9.47499 12 9.47499ZM8.19999 19.3C8.01665 19.1167 7.92499 18.8833 7.92499 18.6C7.92499 18.3167 8.01665 18.0833 8.19999 17.9L11.3 14.8C11.4 14.7 11.5083 14.6293 11.625 14.588C11.7417 14.546 11.8667 14.525 12 14.525C12.1333 14.525 12.2627 14.546 12.388 14.588C12.5127 14.6293 12.6167 14.7 12.7 14.8L15.825 17.925C16.0083 18.1083 16.0957 18.3373 16.087 18.612C16.079 18.8873 15.9833 19.1167 15.8 19.3C15.6167 19.4833 15.3833 19.575 15.1 19.575C14.8167 19.575 14.5833 19.4833 14.4 19.3L12 16.9L9.59999 19.3C9.41665 19.4833 9.18332 19.575 8.89999 19.575C8.61665 19.575 8.38332 19.4833 8.19999 19.3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFold);
export default __webpack_public_path__ + "static/media/ico-fold.8273a9d4ad8d82fae382443221117207.svg";
export { ForwardRef as ReactComponent };